import { render, staticRenderFns } from "./ExternalModule.vue?vue&type=template&id=5446422e&scoped=true&"
import script from "./ExternalModule.vue?vue&type=script&lang=ts&"
export * from "./ExternalModule.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalModule.vue?vue&type=style&index=0&id=5446422e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5446422e",
  null
  
)

export default component.exports